module.exports = __webpack_public_path__ + "static/img/Caleb-Navale.3fe41cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Caleb-Navale.jpg
// module id = vA6g
// module chunks = 0